@if (!selectionHidden() && predictions().length) {
    <div class="shroud" woa-activatable (onActivate)="selectionHidden.set(true)"></div>
}
<div class="location-search">
    <div class="location-search-entry">
        <input class="location-search-entry-input" type="text" data-lpignore="true"
               [(ngModel)]="searchText" woa-activatable (onActivate)="selectionHidden.set(false)">
        @if (!searchText) {
            <div class="location-search-entry-placeholder">
                {{ 'woa.message.location-search.placeholder' | translate }}
            </div>
        }
    </div>
    @if (!selectionHidden() && predictions().length) {
        <div class="location-search-results">
            @for (prediction of predictions(); track prediction; let i = $index) {
                <div class="location-search-results-result" id="prediction-{{i}}"
                     woa-activatable (onActivate)="selectLocation(prediction)">
                    {{ prediction.description }}
                </div>
            }
            <div class="location-search-results-copyright">
                <img width="120" height="14" alt="" ngSrc="assets/images/powered_by_google_on_white.png"/>
            </div>
        </div>
    }
</div>
